import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/transferencia`

    return {
        enviada: {
            datatable(queryParms = {}) {

                return repository.get(`${baseUrl}/datatable-enviada?${urlUtil.serialize(queryParms)}`)
            },
        },
        recebida: {
            datatable(queryParms = {}) {

                return repository.get(`${baseUrl}/datatable-recebida?${urlUtil.serialize(queryParms)}`)
            },
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
        getTransferenciaRecebida(id) {

            return repository.get(`${baseUrl}/transferencia-recebida/${id}`)
        },
        accept(id) {

            return repository.put(`${baseUrl}/${id}/accept`)
        },
        reject(id) {

            return repository.put(`${baseUrl}/${id}/reject`)
        },
    }
}